module.exports = __webpack_public_path__ + "static/img/img_gyl.a799745.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/web_img/img_gyl.png
// module id = BZfi
// module chunks = 1